<template>
  <section>
    <router-view></router-view>

    <manifest></manifest>
  </section>
</template>

<script>
import Manifest from "../../../sender/bookings/Manifest";

export default {
  components: {
    Manifest
  }
}
</script>

<style scoped>
</style>